<!-- 置换时间 -->
<template>
  <zlr-modal v-model="isShow">
    <div class="c-replace">
      <div>
        <h1>置换时间 - 个性化辅导</h1>
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate">
          <FormItem label="被置换模块"
                    prop="module">
            <Select v-model="formValidate.module"
                    placeholder="Select"
                    @on-change="selChange">
              <Option value="MODULE_7">SM个性化辅导</Option>
              <Option value="MODULE_8">CM个性化辅导</Option>
            </Select>
          </FormItem>
          <div class="mentor-detail"
               v-if="mentorDetail">
            <h2>{{ formValidate.module==='MODULE_7'?'SM':'CM' }} - 职业导师个性化辅导</h2>
            <ul>
              <li>{{formValidate.module==='MODULE_7'?'SM个性化辅导':'CM个性化辅导'}} 上限时间：{{mentorDetail.maxTime}}</li>
              <li>{{formValidate.module==='MODULE_7'?'SM个性化辅导':'CM个性化辅导'}} 已使用时间：{{mentorDetail.usedTime}}</li>
              <li>{{formValidate.module==='MODULE_7'?'SM个性化辅导':'CM个性化辅导'}} 剩余时间：{{mentorDetail.remainTime}}</li>
            </ul>
          </div>
          <FormItem label="置换时间给"
                    prop="permuteInModule">
            <Select v-model="formValidate.permuteInModule"
                    placeholder="Select">
              <Option value="7"
                      v-if="formValidate.module === 'MODULE_8'">SM个性化辅导</Option>
              <Option value="8"
                      v-if="formValidate.module === 'MODULE_7'">CM个性化辅导</Option>
            </Select>
          </FormItem>
          <FormItem label="输入置换时间值（mins）"
                    prop="time">
            <Input v-model="formValidate.time"
                   placeholder="Can only enter numbers"></Input>
          </FormItem>
        </Form>
        <p v-show="remainTime">最多能置换：{{remainTime}}</p>
        <div class="c-replace-btn">
          <Button class="zlr-btn-primary"
                  @click="permuteHandle">置换时间</Button>
          <Button class="zlr-btn-default"
                  @click="closeHandle">关闭</Button>
        </div>
      </div>
    </div>
  </zlr-modal>
</template>

<script>
// API
import { subAppPermuteTime, getCsScheduleModule } from '@/api/appointment'
// less
import './public.less'
// componnets
import ZlrModal from '_c/modal/modal'
// validator
import { validateNumber } from '@/libs/validator'
export default {
  name: 'c-replace-diy',
  components: {
    ZlrModal
  },
  data () {
    return {
      isShow: false,
      formValidate: {},
      mentorDetail: '',
      ruleValidate: {
        module: [{ required: true, message: '请选择个性化辅导' }],
        permuteInModule: [{ required: true, message: '请选择个性化辅导' }],
        time: [{ required: true, message: '请输入置换时间值' }, { validator: validateNumber }]
      },
      remainTime: ''
    }
  },
  computed: {},
  mounted () { },
  methods: {
    // 提交置换时间
    permuteHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          let remainTime = this.mentorDetail.remainTime
          if (data.time > remainTime) {
            this.remainTime = remainTime
            return false
          }
          this.isSub = true
          delete data.module
          subAppPermuteTime(data).then(res => {
            this.$zlr_message('置换成功', 'success')
            this.$emit('on-success')
            this.closeHandle()
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    },
    showHandle () {
      this.isShow = true
    },
    closeHandle () {
      this.isShow = false
    },
    // 选择个性化辅导
    selChange (module) {
      getCsScheduleModule({
        module
      }).then(res => {
        this.mentorDetail = res.data.model
        console.log(res)
      })
    },
    resetData () {
      this.$refs['formValidate'].resetFields()
      this.mentorDetail = ''
      this.remainTime = ''
    }
  },
  watch: {
    isShow (value) {
      if (!value) {
        this.resetData()
      }
    }
  }
}
</script>
<style lang='less' scoped>
</style>
